import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { yess, noo } from "../../common/imagePath";

const HelpfulCard = () => {
  const [, setHelpful] = useState(null);
  const { t } = useTranslation();

  return (
    <div className="mx-4 mb-4 rounded-2xl overflow-hidden bg-white border border-[#DEDEDE] dark:bg-[#1B1C1E] dark:border-[#1B1C1E]">
      <div className="px-4 py-5 flex flex-col items-center gap-4">
        <h3 className="text-lg font-inter font-semibold text-[#1C1C1E] dark:text-white text-center">
          {t("common.wasHelpful")}
        </h3>
        <div className="flex gap-4">
          <button
            onClick={() => setHelpful("yes")}
            className="flex items-center justify-center gap-2 w-[92px] h-10 rounded-full bg-[#F3F4F6] dark:bg-[#2C2E30] transition-all duration-200 active:opacity-70"
          >
            <img src={yess} alt="" className="w-5 h-5 object-contain" />
            <span className="text-sm font-semibold text-[#1C1C1E] dark:text-white">
              {t("common.yes")}
            </span>
          </button>
          <button
            onClick={() => setHelpful("no")}
            className="flex items-center justify-center gap-2 w-[92px] h-10 rounded-full bg-[#F3F4F6] dark:bg-[#2C2E30] transition-all duration-200 active:opacity-70"
          >
            <img src={noo} alt="" className="w-5 h-5 object-contain" />
            <span className="text-sm font-semibold text-[#1C1C1E] dark:text-white">
              {t("common.no")}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpfulCard;
